import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useEffect, useState } from 'react'
import { PlusSmIcon } from "@heroicons/react/solid"
import { motion, AnimatePresence } from "framer-motion";
import { useRecoilValue } from 'recoil';
import {darkModeState} from '../../../atoms/darkModeState'
import { apiLink } from '../../../ApiCalls/ApisVariables';
import { globalSelectedOrganization } from '../../../atoms/orgStates';
import { deleteData, getData } from '../../../ApiCalls/DataApis';
import Avatar from '@mui/material/Avatar';
import {MemberTooltip} from '../../../styles/Tooltip'
import { Zoom } from '@mui/material';
import toast from 'react-hot-toast';


function RemoveMemberModal({btnType, remoteOpen,selectedRemoveMember, handleCloseRemoveModal, selectedOrganization, updatedMemberList}) {
  const isDark = useRecoilValue(darkModeState)
  const [isOpen, setIsOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingLastAdmin, setLoadingLastAdmin] = useState(false)
  const [openLastMemberAdmin, setOpenLastMemberAdmin] = useState(false)
  const [lastMemberAdminValue, setLastMemberAdminValue] = useState('delete_member_only')


  function openModal() {
    setIsOpen(true)
  }

  function closeModal() {
    setIsOpen(false)
    handleCloseRemoveModal()
  }

  useEffect(() => {
    if(remoteOpen){
      setIsOpen(true)
    }
  },[remoteOpen])

  const submitRemoveMember = () => {
    try {
      if(!loading){
        setLoading(true)
        deleteData(apiLink + '/v1/organizations/' + selectedOrganization + '/members', 
          {'member_username': selectedRemoveMember.user_username,
          'delete_mode': 'delete_safe'})
            .then(async response => {
              if(response.status == 202){ 
                const data = await response.json();
                setOpenLastMemberAdmin(true)
                // this.setState({lastMemberAdminModalOpen: true}, () => {this.handleClose()})
                
              }else if(response.ok){ 
                toast.success('Member has been removed')
                setLoading(false)
                updatedMemberList()
                closeModal()
              }
              else{
                try{
                  const data = await response.json();
                  toast.error(data.message)
                  setLoading(false)
                }catch (e){
                  toast.error('Something went wrong');
                  setLoading(false)
                }
              }
            })

      }
      
    } catch (error) {
      console.log(error.message)
    }

  }

  const submitLastMember = () => {
    try {
      if(!loadingLastAdmin){
        setLoadingLastAdmin(true)
        deleteData(apiLink + '/v1/organizations/' + selectedOrganization + '/members', 
          {'member_username': selectedRemoveMember.user_username,
          'delete_mode': lastMemberAdminValue})
            .then(async response => {
              if(response.ok){ 
                toast.success('Member has been removed')
                setLoadingLastAdmin(false)
                updatedMemberList()
                closeModal()
              }
              else{
                try{
                  const data = await response.json();
                  toast.error(data.message)
                  setLoadingLastAdmin(false)
                }catch (e){
                  toast.error('Something went wrong');
                  setLoadingLastAdmin(false)
                }
              }
            })

      }
      
    } catch (error) {
      console.log(error.message)
    }

  }

  
  return (
    <>
      <div className="flex items-center justify-center">
        {btnType ==='standardBtn' &&
          <motion.button  whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}  className='btnMain' onClick={openModal}>
              <PlusSmIcon className='btnMainIcon' />
              <span className='btnMainText'>Remove member</span>
          </motion.button>
          }
        {btnType ==='tableBtn' &&
        <motion.button  whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}  className='flex w-20 text-sm items-baseline ml-2' onClick={openModal} >
            <PlusSmIcon className='text-blue-600 w-4 h-4 mt-auto mb-0.5' />
            <span className=' text-blue-600'>Remove</span>
        </motion.button>
          }
        {btnType ==='hideBtn' &&
          <div className='w-0 h-0'>{''}</div>
          }
      </div>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-50" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-scroll">
            <div className="flex min-h-full items-center justify-center p-4 text-center ">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className={`max-w-xl transform overflow-x-hidden rounded-2xl text-left align-middle shadow-xl transition-all ${isDark?'bg-slate-800':'bg-white'}`}>
                  <Dialog.Title
                    as="h3"
                    className={`mb-1 p-4 text-lg font-medium leading-6 border-b-[1px] ${isDark?'text-gray-100 border-gray-700':'text-gray-700 border-gray-200'}`}
                  >
                    Remove member
                  </Dialog.Title>
                  <AnimatePresence exitBeforeEnter>
                  {!openLastMemberAdmin ? (
                    <motion.div
                      key='membersList'
                      initial={{ y: 10, opacity: 0 }}
                      animate={{ y: 0, opacity: 1 }}
                      exit={{ y: -10, opacity: 0 }}
                      transition={{ duration: 0.2 }}
                      className='overflow-y-scroll pt-2 min-w-[375px]'
                    > 
                      <div className={`flex flex-col pl-4 pr-10`}>
                        <div className='flex'>
                          <div>
                            <Avatar sx={{  bgcolor: isDark? '#1e3a8a':'#9ca3af', width: 80, height: 80, }}  src={selectedRemoveMember.user_image_url} />
                          </div>
                          <div className='flex flex-col pl-4 justify-between'>
                              <h1 className={`text-base ${isDark? 'text-gray-300':'text-gray-800'} font-medium truncate`}>{selectedRemoveMember.user_first_name}&nbsp;{selectedRemoveMember.user_last_name}</h1>
                              <h3 className={`pr-1 text-sm ${isDark? 'text-gray-400':'text-gray-600'} font-light truncate italic truncate`}>{selectedRemoveMember.user_username_public}</h3>
                              <h3 className={`pr-1 text-sm ${isDark? 'text-gray-400':'text-gray-500'} font-light truncate truncate`}>{selectedRemoveMember.user_email}</h3>
                          </div>
                        </div>
                      </div>
                      <form >
                        <div className={`flex p-4 px-5 items-center mt-4 border-t-[1px] ${isDark?' border-gray-700':'border-gray-200'}`}>
                          <button
                            type="button"
                            className={`inline-flex rounded-md  bg-transparent border  ${isDark?' border-slate-600 text-gray-400 hover:bg-slate-600':'border-gray-100 text-gray-600 hover:bg-gray-100'} px-4 py-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-500 focus-visible:ring-offset-2`}
                            onClick={closeModal}
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className={`relative cursor-pointer ml-auto inline-flex rounded-md border border-transparent ${isDark?' text-blue-100 bg-blue-900 hover:bg-blue-800 disabled:bg-blue-700':'text-blue-900 bg-blue-100 hover:bg-blue-200 disabled:bg-blue-100'} px-4 py-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-default `}
                            onClick={submitRemoveMember}
                            disabled={loading}
                          >
                            Confirm remove
                            {loading && 
                              <div >
                                  <svg aria-hidden="true" className={`absolute top-1/4 right-1/3 ml-8 w-5 h-15 animate-spin dark:fill-white dark:text-gray-500 fill-blue-600 text-gray-300`} viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"></path>
                                      <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"></path>
                                  </svg>
                              </div>
                            }
                          </button>
                        </div>
                      </form>
                    </motion.div>
                  ):(
                    <motion.div
                        key='lastMemberSection'
                        initial={{ y: 10, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: -10, opacity: 0 }}
                        transition={{ duration: 0.2 }}
                        className='w-full justify-center '
                      >
                        <div className='flex flex-col px-4'>
                          <div className={`text-base mt-4 ${isDark?'text-gray-400':'text-gray-600'} `}>
                          {selectedRemoveMember.user_first_name}&nbsp;{selectedRemoveMember.user_last_name}&nbsp;is the last administrator of at least one project or alert channel. 
                          </div>
                          <div className={`text-base mt-4 text-sm ${isDark?'text-gray-400':'text-gray-600'} `}>
                            Would you like to:
                          </div>
                            <div className='pl-2'>
                              <div className="form-check mt-2">
                                <input className={`form-check-input appearance-none rounded-full h-4 w-4 border ${isDark?'bg-slate-500 border-gray-300':'bg-white border-gray-300'} checked:bg-blue-600 checked:border-blue-500 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer`}
                                      type="radio" 
                                      value="delete_member_only" 
                                      id="delete_member_only" 
                                      checked={lastMemberAdminValue === "delete_member_only"}
                                      onChange={(e) => setLastMemberAdminValue(e.target.value)}
                                  />
                                <label className={`form-check-label inline-block text-sm ${isDark?'text-gray-400':'text-gray-600'} `} htmlFor="delete_member_only">
                                  Keep resources and remove member
                                </label>
                              </div>
                              <div className="form-check mt-2">
                                <input className={`form-check-input appearance-none rounded-full h-4 w-4 border  ${isDark?'bg-slate-500 border-gray-300':'bg-white border-gray-300'} checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer`} 
                                        type="radio" 
                                        value="delete_all_resources" 
                                        id="delete_all_resources"
                                        checked={lastMemberAdminValue === "delete_all_resources"}
                                        onChange={(e) => setLastMemberAdminValue(e.target.value)}
                                />
                                <label className={`form-check-label inline-block text-sm ${isDark?'text-gray-400':'text-gray-600'} `} htmlFor="delete_all_resources">
                                  Delete all resources and member
                                </label>
                              </div>
                            </div>
                        </div>
                        <form >
                          <div className={`flex p-4 px-5 items-center mt-4 border-t-[1px] ${isDark?' border-gray-700':'border-gray-200'}`}>
                            <button
                              type="button"
                              className={`inline-flex rounded-md  bg-transparent border  ${isDark?' border-slate-600 text-gray-400 hover:bg-slate-600':'border-gray-100 text-gray-600 hover:bg-gray-100'} px-4 py-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-500 focus-visible:ring-offset-2`}
                              onClick={closeModal}
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              className={`relative cursor-pointer ml-auto inline-flex rounded-md border border-transparent ${isDark?' text-blue-100 bg-blue-900 hover:bg-blue-800 disabled:bg-blue-700':'text-blue-900 bg-blue-100 hover:bg-blue-200 disabled:bg-blue-100'} px-4 py-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-default `}
                              onClick={submitLastMember}
                              disabled={loadingLastAdmin}
                            >
                              Confirm
                              {loadingLastAdmin && 
                                <div >
                                    <svg aria-hidden="true" className={`absolute top-1/4 right-1/3 ml-8 w-5 h-15 animate-spin dark:fill-white dark:text-gray-500 fill-blue-600 text-gray-300`} viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"></path>
                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"></path>
                                    </svg>
                                </div>
                              }
                            </button>
                          </div>
                        </form>

                    </motion.div>
                  )}
                  
                    
                    


                  </AnimatePresence>
                  
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}

export default RemoveMemberModal